import React, { createContext, useContext, ReactNode } from 'react';
import { useNotificationStateHook, NotificationState } from '../hooks';

interface NotificationContextType extends NotificationState {
  // Métodos adicionales del context si los necesitas
}

const NotificationContext = createContext<NotificationContextType | undefined>(undefined);

interface NotificationProviderProps {
  children: ReactNode;
}

export const NotificationProvider: React.FC<NotificationProviderProps> = ({ children }) => {
  const notificationState = useNotificationStateHook();

  return (
    <NotificationContext.Provider value={notificationState}>
      {children}
    </NotificationContext.Provider>
  );
};

// Hook para usar el contexto de notificaciones
function useNotificationContextHook(): NotificationContextType {
  const context = useContext(NotificationContext);
  
  if (context === undefined) {
    throw new Error('useNotificationContextHook must be used within a NotificationProvider');
  }
  
  return context;
}

// Exportar el hook de manera compatible con Fast Refresh
export { useNotificationContextHook as useNotificationContext };

// Exportar el provider como default
export default NotificationProvider;
